import {getQuantityOrderedViaUom} from "../../order/quantity";
import MapUtil from "../../logic/collection/mapUtil";

export const DISCOUNTRULETYPE_IsCollection = "IC";
export const DISCOUNTRULETYPE_OrderSize = "OS";
export const DISCOUNTRULETYPE_Break = "BR";

const getDiscountName = (discountType) => {
    switch (discountType) {
        case DISCOUNTRULETYPE_IsCollection: return "Is Collection";
        case DISCOUNTRULETYPE_OrderSize: return "Order Size";
        case DISCOUNTRULETYPE_Break: return "Multi Buy";
        default: return "";
    }
}

const getDiscountValue = (discount, uom) => {
    const discountType = discount.type;
    switch (discountType) {
        case DISCOUNTRULETYPE_IsCollection:
            return "Collecting";
        case DISCOUNTRULETYPE_OrderSize:
            return "£" + discount.min_amt + "+";
        case DISCOUNTRULETYPE_Break:
            return getQuantityOrderedViaUom(discount.break_val, uom) + "+";
        default:
            return "";
    }
}

// const orderedDiscountTypesList = [
//     DISCOUNTRULETYPE_IsCollection,
//     DISCOUNTRULETYPE_OrderSize,
//     DISCOUNTRULETYPE_Break
// ]
const orderedDiscountTypesMap = {
    [DISCOUNTRULETYPE_IsCollection]:10,
    [DISCOUNTRULETYPE_OrderSize]:20,
    [DISCOUNTRULETYPE_Break]:30
}

const sortDiscountsInPlace = (discountArr) => {
    if(!discountArr) return;
    discountArr.sort((a, b) => {
        const typeCompare = orderedDiscountTypesMap[a.type] - orderedDiscountTypesMap[b.type];
        if (typeCompare !== 0) return typeCompare;
        return b.seqNo - a.seqNo;
    });
}

const sortDiscounts = (discountArr) => {
    if(!discountArr) return [];
    const arr = [...discountArr];
    sortDiscountsInPlace(arr);
    return arr;
}

const groupDiscountsByType = (discountArr) => {
    return discountArr.reduce((acc, discount) => {
        acc[discount.type] = acc[discount.type] || [];
        acc[discount.type].push(discount);
        return acc;
    }, {});
}

const getGroupedList = (discountArr) => {
    if(!discountArr) return [];
    const list = MapUtil.mapToList(groupDiscountsByType(discountArr), (k,v) => ({type: k, rules: v}));
    list.sort((a,b) => orderedDiscountTypesMap[a.type] - orderedDiscountTypesMap[b.type]);
    list.forEach(({rules}) => sortDiscountsInPlace(rules));
    return list;
}

const getRuleName = (rule, uom) => {
    const discountType = rule.type;
    switch (discountType) {
        case DISCOUNTRULETYPE_IsCollection:
            return "Collection";
        case DISCOUNTRULETYPE_OrderSize:
            return "Order Size: £" + rule.min_amt + "+";
        case DISCOUNTRULETYPE_Break:
            return "Multi Buy: " + rule.break_val + "+";
        default:
            return "";
    }
}

const getPreferenceOptions = (discountSchema) => {
    const rules = discountSchema.M_DiscountSchemaRule;
    if(!rules) return [];

    const mappedDiscounts = rules.reduce((acc, discount) => {
        acc[discount.DiscountRuleType.id] = acc[discount.DiscountRuleType.id] || [];
        acc[discount.DiscountRuleType.id].push(discount);
        return acc;
    }, {});
    const options = [];
    for (const type of Object.keys(mappedDiscounts)) {
        if (type === DISCOUNTRULETYPE_IsCollection) {
            options.push({name: "Collection", values: ["Collection", "Delivery"]});
        } else if (type === DISCOUNTRULETYPE_OrderSize) {
            const rules = mappedDiscounts[type];
            const orderSizes = ['0+', ...rules.map(r => r.MinimumAmt + "+")];
            const values = [...new Set(orderSizes)];
            options.push({name: "Order Size", values});
        }
    }
    return options;
}

export const DiscountDetail = {
    getDiscountName,
    getDiscountValue,
    sortDiscounts,
    groupDiscountsByType,
    getGroupedList,
    getRuleName,
    getPreferenceOptions
}